<template>
  <div class="loading-state">
    <SkeletonTenderList :item-count="20" />
  </div>
</template>

<script setup lang="ts">
import SkeletonTenderList from "@/components/MyTenders/SkeletonTenderList.vue";
</script>

<style lang="scss" scoped>
.loading-state {
  position: relative;
}
</style>
